import AddFolderComponent from './add-folder';
import options from './tree.component';

const Component = {
    selector: 'dtAdminFolderTree',
    options
};

export {
    AddFolderComponent,
    Component
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-tree/index.js